import React from 'react';
import './Modals.css';
import {useSelector} from "react-redux"; // Zakładam wspólny plik CSS dla modali, kod poniżej

import { ReactComponent as UserSquare } from '../icons/user-square.svg';


const ProfileModal = ({ onClose, onChangePassword }) => {
    const email = useSelector((state) => state.tokens.userEmail);
    const phone = useSelector((state) => state.tokens.userPhoneNumber);
    return (
        <div className="modal-overlay">
            <div className="modal-content profile-modal">
                <div className="modal-header">
                    <h3><UserSquare></UserSquare> Profil</h3>
                    <button className="close-btn" onClick={onClose}>&times;</button>
                </div>
                <div className="modal-body">
                    <div className="input-group">
                        <label>Adres email</label>
                        <input className="password" type="email" value={email || ""} readOnly />
                    </div>
                    <div className="input-group">
                        <label>Numer telefonu</label>
                        <input className="password" type="email" value={phone || ""} readOnly />
                    </div>
                    <div className="input-group">
                        <label>Hasło</label>
                        <input className="password" type="password" value="***********" readOnly />
                    </div>
                    <div className="modal-actions-link">
                        <span className="link-green" onClick={onChangePassword}>Zmień hasło</span>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default ProfileModal;